@if (!!model.id) {
<div class="p1">
    <p class="fw-bold h3"
       data-cs-mask>
        {{model.data.firstname}} {{model.data.lastname}}
    </p>
    <p data-cs-mask>
        {{model.data.street_1}} {{model.data.street_2}}
    </p>
    <p data-cs-mask>
        {{model.data.postcode}} {{model.data.city}}
    </p>
    <p data-cs-mask>{{model.regionName}}</p>
    <p data-cs-mask>{{model.countryName}}</p>
    @if (model.data.telephone) {
    <p data-cs-mask>
        {{'Phone' | translate}} {{model.data.telephone}}
    </p>
    }
</div>
} @else {
<div class="p1">{{'No data provided' | translate}}</div>
}
